document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Swiper instances
  document.querySelectorAll('.swiper').forEach(function(el) {
    if (el.classList.contains('swiper-initialized')) return;
    var isThumb = el.classList.contains('swiper-free-mode');
    new Swiper(el, {
      slidesPerView: isThumb ? 'auto' : 1,
      spaceBetween: isThumb ? 8 : 16,
      freeMode: isThumb,
      watchSlidesProgress: isThumb,
      loop: false,
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      navigation: {
        prevEl: el.parentElement.querySelector('button:first-of-type'),
        nextEl: el.parentElement.querySelector('button:last-of-type')
      },
      breakpoints: { 768: { slidesPerView: isThumb ? 'auto' : 3 } }
    });
  });

  // FAQ accordion
  document.querySelectorAll('[data-faq-index], [data-faq-id]').forEach(function(item) {
    var header = item.querySelector('[style*="cursor: pointer"]');
    if (!header) return;
    header.addEventListener('click', function() {
      var content = item.querySelector('[style*="grid-template-rows"], [style*="max-height"]');
      if (!content) return;
      var isOpen = content.style.gridTemplateRows === '1fr' || content.style.maxHeight !== '0px';
      if (content.style.gridTemplateRows !== undefined) {
        content.style.gridTemplateRows = isOpen ? '0fr' : '1fr';
      } else {
        content.style.maxHeight = isOpen ? '0px' : '500px';
        content.style.opacity = isOpen ? '0' : '1';
      }
      var icon = header.querySelector('span[style*="transform"]');
      if (icon) icon.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(45deg)';
    });
  });
});
